import React, { useMemo, useState, useEffect } from "react";
import "../modules/AboutPage.css";
import { useT, useI18nReady } from "../components/TextProvider";

// Counter animatsiya komponenti
function StatCounter({ target }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // Agar target raqam bo'lsa, uni extract qilish
    const numTarget = parseInt(target.toString().replace(/\D/g, '')) || 0;
    
    if (numTarget === 0) {
      setCount(target);
      return;
    }

    let current = 0;
    const duration = 2000; // 2 soniya
    const steps = 60;
    const increment = numTarget / steps;
    const stepDuration = duration / steps;

    const interval = setInterval(() => {
      current += increment;
      if (current >= numTarget) {
        setCount(target);
        clearInterval(interval);
      } else {
        setCount(Math.floor(current) + target.toString().replace(/\d/g, '').substring(0, 1));
      }
    }, stepDuration);

    return () => clearInterval(interval);
  }, [target]);

  return <>{count}</>;
}

// Yangi counter komponenti - samarali versiya
function AnimatedCounter({ target }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const numMatch = target.toString().match(/\d+/);
    const numValue = numMatch ? parseInt(numMatch[0]) : 0;
    const suffix = target.toString().replace(/\d+/, '');

    if (numValue === 0) return;

    let current = 0;
    const duration = 2000;
    const steps = 60;
    const increment = numValue / steps;
    const stepDuration = duration / steps;

    const interval = setInterval(() => {
      current += increment;
      if (current >= numValue) {
        setCount(numValue + suffix);
        clearInterval(interval);
      } else {
        setCount(Math.floor(current) + suffix);
      }
    }, stepDuration);

    return () => clearInterval(interval);
  }, [target]);

  return <>{count}</>;
}

export default function AboutPage() {
  const t = useT();
  const ready = useI18nReady();

  const year = useMemo(() => new Date().getFullYear(), []);

  const [openIdx, setOpenIdx] = useState(null);
  // Если переводы ещё не готовы — можно ничего не рендерить
  if (!ready) {
    return null; // или лоадер
  }

  const brand = t("aboutTitle");
  const tagline = t("aboutSub");

  const stats = [
    { k: t('firstStat'), v: t('aboutStud') },
    { k: t('secondStat'), v: t('secondStatText') },
    { k: t('thirdStat'), v: t('thirdStatText') },
    { k: t('fourthStat'), v: t('fourthStatText') },
  ];

  const values = [
    { title: t('QadriyatlarS'), text: t('QadriyatlarT1') },
    { title: t('QadriyatlarS2'), text: t('QadriyatlarT2') },
    { title: t('QadriyatlarS3'), text: t('QadriyatlarT3') },
    { title: t('QadriyatlarS4'), text: t('QadriyatlarT4') },
  ];

  // const timeline = [
  //   { year: "2022", title: "G'oya", text: "Universitetlar uchun birinchi ko'rsatmalar." },
  //   { year: "2023", title: "Пилот", text: "Запуск открытых уроков и библиотеки шаблонов." },
  //   { year: "2024", title: "Рост", text: "Партнёрства с университетами и школами." },
  //   { year: "2025", title: "Платформа", text: "Интерактивные курсы и сертификация навыков." },
  // ];

  const team = [
    { name: t('teamRole'), role: t('teamRoles'), photo: t('teamPhoto') },
    { name: t('team2Name'), role: t('team2Role'), photo: t('team2Photo') },
    { name: t('team3Name'), role: t('team3Role'), photo: t('team3Photo') },
    { name: t('team4Name'), role: t('team4Role'), photo: t('team4Photo') },
  ];

  const faqs = [
    { q: t('faqsQ1'), a: t('faqsA1') },
    { q: t('faqsQ2'), a: t('faqsA2') },
  ];

  const toggleFAQ = (i) => setOpenIdx((v) => (v === i ? null : i));

  return (
    <main className="about">
      <div className="about__accent" aria-hidden="true" />

      {/* Hero */}
      <header className="about__hero" aria-label="Biz haqimizda – Kirish">
        <h1 className="about__title">{brand}</h1>
        <p className="about__tagline">{tagline}</p>
      </header>

      {/* Метрики */}
      <section className="about__stats" aria-label="Asosiy ko'rsatkichlar">
        {stats.map((s) => (
          <article key={s.k} className="stat">
            <div className="stat__k">
              <AnimatedCounter target={s.k} />
            </div>
            <div className="stat__v">{s.v}</div>
          </article>
        ))}
      </section>

      {/* Миссия и ценности */}
      <section className="about__mission grid" aria-label="Missiya va qadriyatlar">
        <article className="card mission">
          <h2>{t('Missiyamiz')}</h2>
          <p>
            {t('missiyaDesc')}
          </p>
          <ul className="checks">
            <li>{t('check1')}</li>
            <li>{t('check2')}</li>
            <li>{t('check3')}</li>
          </ul>
        </article>

        <article className="card values">
          <h2>{t('Qadriyatlar')}</h2>
          <div className="values__list">
            {values.map((v) => (
              <div className="value" key={v.title}>
                <div className="value__dot" aria-hidden />
                <h3>{v.title}</h3>
                <p>{v.text}</p>
              </div>
            ))}
          </div>
        </article>
      </section>

      {/* Таймлайн */}
      {/* <section className="about__timeline card" aria-label="История и этапы">
        <h2>Как мы развивались</h2>
        <ol className="timeline">
          {timeline.map((t, i) => (
            <li className="timeline__item" key={t.year}>
              <div className="timeline__dot" aria-hidden />
              <div className="timeline__year">{t.year}</div>
              <div className="timeline__content">
                <h3>{t.title}</h3>
                <p>{t.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </section> */}

      {/* Команда */}
      <section className="about__team card" aria-label="Наша команда">
        <h2>{t('Jamoa')}</h2>
        <div className="team">
          {team.map((m) => (
            <div className="member" key={m.name}>
              <div className="avatar" aria-label={m.name}>
                {m.photo ? <img src={m.photo} alt={m.name} /> : <span>{initials(m.name)}</span>}
              </div>
              <div className="member__meta">
                <strong>{m.name}</strong>
                <span className="muted">{m.role}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="about__faq card" aria-label="Частые вопросы">
        <h2>FAQ</h2>
        <div className="faq">
          {faqs.map((f, i) => (
            <details key={f.q} open={openIdx === i} onClick={(e) => e.preventDefault()}>
              <summary onClick={() => toggleFAQ(i)}>
                <span>{f.q}</span>
                <span className={`chev ${openIdx === i ? "up" : ""}`} aria-hidden>
                  ▾
                </span>
              </summary>
              <p>{f.a}</p>
            </details>
          ))}
        </div>
      </section>

      {/* Контакты и партнёрство */}
      {/* <section className="about__cta grid" aria-label="Связаться с нами">
        <article className="card partners">
          <h2>{t('hamkorlar')}</h2>
          <p className="muted">{t('weWork')}</p>
          <div className="logos" role="list" aria-label="Логотипы партнёров">
            <div className="logo">UniLab</div>
            <div className="logo">Eduskill</div>
            <div className="logo">TechHub</div>
            <div className="logo">OpenAI Edu</div>
            <div className="logo">DataCamp</div>
            <div className="logo">ML School</div>
          </div>
        </article>
      </section> */}
    </main>
  );
}

function initials(name) {
  const parts = name.split(" ").filter(Boolean);
  const first = parts[0]?.[0] || "";
  const last = parts[parts.length - 1]?.[0] || "";
  return (first + last).toUpperCase();
}
